import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { getSingularFormForHandlingUnitType } from "@/Data/getSingularFormForHandlingUnitType";
import { getPluralFormForHandlingUnitType } from "@/Data/getPluralFormForHandlingUnitType";

export function getSingularOrPluralFormForHandlingUnitType(
  handlingUnitType: HandlingUnitType,
  numberItems: number,
) {
  if (numberItems === 1) {
    return getSingularFormForHandlingUnitType(handlingUnitType);
  } else {
    return getPluralFormForHandlingUnitType(handlingUnitType);
  }
}
